import React from 'react';
import DesktopAdhesionGak from './gak/DesktopAdhesion';
const DesktopAdhesion = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopAdhesionGak, {
        safety: safety
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
